import { Navigate, Outlet } from 'react-router';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useServiceStatus } from '../hooks/useServiceStatus';
import { routes } from '../routes';

export default function ServiceGuard() {
  const { data: isReachable, isLoading } = useServiceStatus();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: 2 }}>
        <CircularProgress />
        <Typography color="text.secondary">Conectando con FilesWatcher…</Typography>
      </Box>
    );
  }

  if (!isReachable) {
    return <Navigate to={routes.home.path} replace />;
  }

  return <Outlet />;
}
